const categorizeTagTitleKo = ['인사', '감정', '상황', '활동', '인물 & 캐릭터', '동물', '음식 & 음료', '사물', '여행 & 장소']
export default categorizeTagTitleKo
